<base-node [node]="node">
    <div>
        <mat-icon svgIcon="netra-icon" class="netra-icon" [routerLinkActive]="['matlist-icon-active']">
        </mat-icon>
        <h6>{{node.device.name}}</h6>
        <div class="flex-row center mt-20">
            <div class="flex-row gap-small">
                <button mat-icon-button class="hover-button" (click)="openChartNode(node)" matTooltip="PSD Distribution" [matTooltipPosition]="'below'">
                    <mat-icon svgIcon="psd-white"></mat-icon>
                </button>
                <button *ngIf="hasUpstreamConnection" type="button" class="reduction-ratio-button"
                    (click)="openReductionRatio($event)"
                    [disabled]="!reductionRatio"
                    [matTooltip]="reductionRatio ? 'View D80 Reduction Ratio' : 'D80 Reduction Ratio unavailable'"
                    [matTooltipPosition]="'below'">
                    <span class="reduction-ratio-label">RR</span>
                    <span class="reduction-ratio-value">
                        {{ reductionRatioLoading ? '…' : (reductionRatio ? (reductionRatio.ratio | number:'1.1-1') : '—') }}
                    </span>
                </button>
                <!-- To Be Implemented -->
                <!-- <button mat-icon-button class="hover-button" [ngClass]="{ 'threshold-true': node.threshold }"
                    matTooltip="Threshold Alert" [matTooltipPosition]="'right'">
                    <mat-icon>add_alert</mat-icon>
                </button> -->
            </div>
        </div>
    </div>
</base-node>
